import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';

export default function MerchantList(props) {
  const listItemStyle = { textAlign: 'right',cursor:'pointer' };
  const clickHandler=(e)=>{
    props.handleDialogOpen(e)
  };
  const listItems = props.merchantMarkers.map((item, index) => {
    return <div key={index}>
      <ListItem alignItems="flex-start" style={listItemStyle} onClick={()=>clickHandler(item)}>
        <ListItemAvatar>
          <Avatar alt="Remy Sharp" src="" style={{ background: '#db5726' }}>{item.name.charAt(0)}</Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={item.name}
          secondary={
            <React.Fragment>
              <Typography
                sx={{ display: 'inline' }}
                component="span"
                variant="body2"
                color="text.primary"
              >
                {item.address}
              </Typography>
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="fullWidth" component="li" />
    </div>
  });
  return (
    <>
      <List sx={{ width: '90%', bgcolor: 'background.paper' }} style={{ margin: 'auto', maxHeight: '50vh', overflow: 'auto' }}>
        {listItems}
      </List>
    </>
  );
}
